// ─── NAVIGATION ───
export const NAV_ITEMS = [
  {
    label: 'О нас',
    href: '#about',
    submenu: [
      { label: 'История и функционал', href: '#story' },
      { label: 'Совет директоров', href: '#board' },
      { label: 'Правление', href: '#management' },
      
      { label: 'Руководство', href: '#directors' },
      
      { label: 'Организационная структура', href: '#structure' },
      
    ]
  },
  { label: 'ГОНС и Келешек', href: '#pnf-gons' },
  {
    label: 'Подушевое нормативное финансирование',
    href: '#pnf',
    submenu: [
      { label: 'Дошкольное образование', href: '#pnf-preschool' },
      { label: 'Среднее образование', href: '#pnf-school' },
      { label: 'ТиППО', href: '#pnf-tippo' },
      { label: 'ОВПО', href: '#pnf-ovpo' },
      { label: 'Дополнительное образование', href: '#pnf-extra' },
    ]
  },
  
  {
    label: 'Отработка грантов',
    href: '#working-off',
    submenu: [
      { label: 'Бакалавриат', href: '#working-off-bachelor' },
      { label: 'Магистратура', href: '#working-off-magistracy' },
      { label: 'Докторантура', href: '#working-off-doctoral' },
      { label: 'Оплата задолженности', href: '#working-off-payment' },
    ]
  },
  { label: 'Инвесторам', href: '#investors' },
  { label: 'Новости', href: '#news' },
  { label: 'Контакты', href: '#contacts' },
];

// ─── HERO SLIDES ───
export const HERO_SLIDES = [
  {
    badge: 'АО «Финансовый Центр» - Казахстан',
    title: ['Интегратор', 'финансирования', 'госпрограмм'],
    highlight: 2,
    subtitle: 'Разрабатываем и сопровождаем цифровые, нормативные и аналитические механизмы распределения средств. Прозрачные правила. Сопоставимые параметры. Данные в основе решений.',
    cta1: { label: 'О программах', href: '#pnf' },
    cta2: { label: 'История', href: '#story' },
  },
  {
    badge: 'Образовательная накопительная система',
    title: ['ГОНС и', 'программа', 'Келешек'],
    highlight: 2,
    subtitle: 'Государственная образовательная накопительная система - инвестиции в будущее каждого ребёнка. Накопления, гранты и кредиты в единой цифровой экосистеме.',
    cta1: { label: 'Подробнее', href: '#pnf-gons' },
    cta2: { label: 'FAQ', href: '#faq' },
  },
  {
    badge: 'Цифровая трансформация',
    title: ['Единая', 'платформа', 'e-Qazyna'],
    highlight: 2,
    subtitle: 'Переход от 8 разрозненных систем к единому порталу e-Qazyna. Прозрачность, автоматизация и исключение нецелевых расходов на всех уровнях образования.',
    cta1: { label: 'Стратегия 2028', href: '#strategy' },
    cta2: { label: 'Презентация', href: '#faq' },
  },
];

// ─── TICKER ITEMS ───
export const TICKER_ITEMS = [
  'Ваучерное финансирование дошкольного образования: 11 909 садов, 988 тыс. воспитанников',
  'Среднее образование: 9 193 школы, 3 964 тыс. учащихся - перевод в e-Qazyna',
  'ТиПО: 763 колледжа, 556 тыс. студентов, норматив 528 177 тенге',
  'ОВПО: 123 ВУЗа, 752 тыс. студентов, объём госзаказа ~504 млрд тенге',
  'Стипендии ОВПО: 240 тыс. студентов, ~174 млрд тенге на 2026 год',
  'ГОНС «Келешек»: 190 522 вклада в БВУ и КСЖ, 35,9 млрд тенге накоплений',
  'Цифровая трансформация: дедлайн оцифровки всех уровней образования - 2026 год',
];

// ─── STATS ───
export const STATS = [
  { num: '5.3', unit: 'трлн тг', label: 'Объём госзаказа 2026', sub: 'по всем уровням образования' },
  { num: '25+', unit: 'K', label: 'Организаций образования', sub: 'в цифровом реестре e-Qazyna' },
  { num: '2M+', label: 'Получателей финансирования', sub: 'студентов, воспитанников, учащихся' },
  { num: '2028', label: 'Инвестиционная модель', sub: 'целевой год трансформации' },
];

// ─── PNF PROGRAMS (CAROUSEL ITEMS) ───
export const PNF_PROGRAMS = [
  {
    id: 'gons',
    tag: 'ГОНС и Келешек',
    icon: 'savings',
    title: 'Государственная образовательная накопительная система',
    subtitle: 'НацФонд-детям, Келешек, депозиты «Акыл»',
    stats: [
      { v: '190 522', l: 'вкладов в БВУ/КСЖ' },
      { v: '35,9 млрд', l: 'накоплений' },
      { v: '11,2 млрд', l: 'премий государства' },
      { v: '357,5 тыс.', l: 'выпускников на мониторинге' },
    ],
    portals: [],
    desc: 'НацФонд-детям: 1-18 лет, 232,94 $ в 2025 году. Депозит «Акыл» без ограничения возраста. Премия государства: 7% (СУСН), 5% (все). СОК: 60 МРП для всех детей в 5 лет.',
  },
  {
    id: 'preschool',
    tag: 'Дошкольное образование',
    icon: 'preschool',
    title: 'Дошкольное воспитание и обучение',
    subtitle: 'Ваучерное финансирование частных и государственных садов',
    stats: [
      { v: '11 909', l: 'детских садов' },
      { v: '988 тыс.', l: 'воспитанников' },
      { v: '61 901 тг', l: 'средний норматив' },
      { v: '~924 млрд', l: 'объём госзаказа 2026' },
    ],
    portals: [],
    desc: '2 механизма реализации пилотного проекта. С марта 2026 года - масштабный переход на e-Qazyna. В норматив входит ФОТ, учебные расходы, содержание здания.',
  },
  {
    id: 'school',
    tag: 'Среднее образование',
    icon: 'school',
    title: 'Среднее образование',
    subtitle: 'Подушевое нормативное финансирование школ',
    stats: [
      { v: '9 193', l: 'школы' },
      { v: '3 964 тыс.', l: 'учащихся' },
      { v: '683 559 тг', l: 'норматив (гос.)' },
      { v: '~3,6 трлн', l: 'объём госзаказа 2026' },
    ],
    portals: [
      { label: 'По школам', url: 'https://orta-bilim.e-qazyna.kz/ru/refs/by-schools', embed: true },
      { label: 'По бюджету', url: 'https://orta-bilim.e-qazyna.kz/ru/refs/by-budget?Year=2026', embed: true },
      { label: 'Аналитика', url: 'https://orta-bilim.e-qazyna.kz/ru/refs/analytics', embed: true },
    ],
    desc: 'Оцифровка государственных школ в e-Qazyna - с 12 февраля 2026. Компоненты А2/А3 для частных школ. 416 тыс. педагогов.',
  },
  {
    id: 'tippo',
    tag: 'ТиПО',
    icon: 'tippo',
    title: 'Техническое и профессиональное образование',
    subtitle: 'Ранжирование колледжей по лигам и группам затратности',
    stats: [
      { v: '763', l: 'колледжа' },
      { v: '556 тыс.', l: 'студентов' },
      { v: '528 177 тг', l: 'средний норматив' },
      { v: '~514 млрд', l: 'объём госзаказа 2026' },
    ],
    portals: [],
    desc: '4 группы затратности (А, Б, В, Г) и 3 лиги качества. С мая 2026 - перевод в e-Qazyna. 60,8 млрд тенге на ранжирование в 2026 году.',
  },
  {
    id: 'ovpo',
    tag: 'ОВПО',
    icon: 'ovpo',
    title: 'Высшее и послевузовское образование',
    subtitle: 'Госзаказ для казахстанских и иностранных ВУЗов',
    stats: [
      { v: '123', l: 'ВУЗа' },
      { v: '752 тыс.', l: 'студентов' },
      { v: '947 205 тг', l: 'норматив (без особ. ст.)' },
      { v: '~504 млрд', l: 'объём госзаказа 2026' },
    ],
    portals: [],
    desc: 'До декабря 2026 - перевод в e-Qazyna. Новая формула Z1+Z2+Z3 для единого расчёта. 15 ВУЗов с иностранным участием.',
  },
  {
    id: 'extra',
    tag: 'Дополнительное образование',
    icon: 'palette',
    title: 'Дополнительное образование',
    subtitle: 'Ваучерная система финансирования кружков и секций',
    stats: [
      { v: '3 674', l: 'организации' },
      { v: '1,15 млн', l: 'обучающихся' },
      { v: '132 128', l: 'кружков и секций' },
      { v: '~154 млрд', l: 'объём госзаказа 2026' },
    ],
    portals: [],
    desc: 'Пилот с 1 июня 2025 года (1 728 частных ОДО). Завершение пилота - 1 сентября 2026. Города: Астана (qosymsha.kz), Шымкент (Миндаль).',
  },
  {
    id: 'dorms',
    tag: 'Общежития',
    icon: 'dorms',
    title: 'Обеспечение студентов местами в общежитиях',
    subtitle: 'Государственный заказ по обеспечению койко-мест',
    stats: [
      { v: '129', l: 'общежитий' },
      { v: '33 тыс.', l: 'койко-мест' },
      { v: '11,5 млрд', l: 'запланировано на 2026' },
      { v: '14,5 млрд', l: 'потребность доп. финансирования' },
    ],
    portals: [],
    desc: 'По 72 общежитиям: МНВО - 7,6 млрд тг, МП - 3,9 млрд тг. Механизм предварительных договоров и соглашений о неизменности целевого назначения.',
  },
];

// ─── TIMELINE ───
export const TIMELINE = [
  { year: '2003', tag: 'Основание', title: 'Запуск финансового оператора', desc: 'Формирование института, обеспечивающего реализацию механизмов финансирования в социальной сфере.' },
  { year: '2011', tag: 'Системность', title: 'Единая методология и нормативные модели', desc: 'Развитие нормативных принципов распределения средств и сопоставимости параметров по программам.' },
  { year: '2016', tag: 'Цифровизация', title: 'Переход к цифровым реестрам', desc: 'Автоматизация процессов, верификация данных и снижение доли ручного контроля при распределении средств.' },
  { year: '2020', tag: 'Аналитика', title: 'Мониторинг и оценка эффективности', desc: 'Сводные витрины показателей, контроль качества данных и метрики эффективности реализации госпрограмм.' },
  { year: '2022', tag: 'ГОНС', title: 'Государственная накопительная система', desc: '«Келешек» - массовый охват детей депозитами «Акыл», интеграция с БВУ и КСЖ по всей стране.' },
  { year: '2025', tag: 'Трансформация', title: 'Стратегическое переосмысление', desc: 'Ребрендинг в «Интегратор финансирования госпрограмм». Концепция инвестиционной модели к 2028 году.' },
  { year: '2026', tag: 'e-Qazyna', title: 'Единая цифровая платформа', desc: 'Все уровни образования переходят в систему e-Qazyna. Исключение фрагментации из 8 систем.' },
];

// ─── BOARD MEMBERS (from fincenter.kz/about/board-directors) ───
export const BOARD_MEMBERS = [
  { initials: 'СД', name: 'Председатель Совета директоров', role: 'Совет директоров', img: null },
  { initials: 'НМ', name: 'Независимый директор', role: 'Аудит и риски', img: null },
  { initials: 'АК', name: 'Независимый директор', role: 'Стратегия', img: null },
  { initials: 'БС', name: 'Независимый директор', role: 'Финансы', img: null },
];

// ─── MANAGEMENT (from fincenter.kz/about/management) ───
export const MANAGEMENT = [
  { initials: 'ПП', name: 'Председатель Правления', role: 'Утельбаева Шолпан Ануарбекқызы', isChair: true, img: null },
  { initials: 'ЗП', name: 'Заместитель Председателя', role: 'Операционная эффективность и качество данных', isDeputy: true, img: null },
  { initials: 'ЗП', name: 'Заместитель Председателя', role: 'Цифровые платформы и интеграции', isDeputy: true, img: null },
];

// ─── DEPARTMENT DIRECTORS ───
export const DIR_CARDS = [
  { initials: 'УП', name: 'Маженова Гульжан Муратовна', dept: 'Управляющий директор' },
  { initials: 'ЦП', name: 'Кайрат Какимович', dept: 'Руководитель аппарата' },
  { initials: 'С', name: 'Садыков Нуржан Кабдылкадырович', dept: 'Советник' },
  { initials: 'ПБ', name: 'Алгожина Жанар Казбековна', dept: 'Директор департамента исследований и методологии' },
  { initials: 'ОК', name: 'Амреева Гульмира Молдашевна', dept: 'Директор департамента аналитики и инфраструктурного развития' },
  { initials: 'КМ', name: 'Баекеева Гульсара Галимовна', dept: 'Директор департамента экономики и бухгалтерского учета' },
  { initials: 'ГО', name: 'Исабаев Аскар Муратович', dept: 'Директор департамента (и.о. директора департамента расчетов)' },
  { initials: 'БТ', name: 'Сыздыков Барик Айтенович', dept: 'Директор департамента мониторинга' },
  { initials: 'БТ', name: 'Абкенов Канат Токтарович', dept: 'Директор департамента Data-аналитики и сопровождения' },
  { initials: 'БТ', name: 'Рахимбеков Болат Аскербекович', dept: 'Директор департамента административной работы' },
  { initials: 'БТ', name: 'Махашова Меруерт Жаксибаевна', dept: 'Директор юридического департамента' },
  { initials: 'БТ', name: 'Досмурзинова Ботагоз Кусаиновна', dept: 'Корпоративный секретарь' },
  // { initials: 'БТ', name: 'Комплаенс-офицер',dept: 'Корпоративный секретарь' },
  { initials: 'БТ', name: 'Ракишева Алмагуль Сейлхановна', dept: 'Служба внутреннего аудита' },
];

// ─── НАША КОМАНДА ───
export const TEAM_CARDS = [
  { initials: 'АА', name: 'Имя Фамилия', dept: 'Должность', image: null },
  { initials: 'ББ', name: 'Имя Фамилия', dept: 'Должность', image: null },
  // добавляй сколько нужно...
];

// ─── NEWS ───
export const NEWS = [
  {
    tag: 'Главное',
    date: '2026-04-10',
    title: 'Трансформация АО «Финансовый центр»',
    excerpt: 'Сегодня мы провели стратегическую сессию с командой АО «Финансовый центр» по реализации разработанной нами концепции трансформации финансирования сферы образования.',
    image: '10-04',
    featured: true,
  },
  {
    tag: 'ГОНС',
    date: '20 апреля 2026',
    title: 'По программе ГОНС «Келешек» расширяется охват накопительных образовательных продуктов',
    excerpt: 'Финансовый центр усиливает сопровождение вкладчиков и цифровое взаимодействие с банками и страховыми организациями.',
    image: '10-06',
  },
  {
    tag: 'Дошкольное',
    date: '16 апреля 2026',
    title: 'Ваучерное финансирование дошкольного образования масштабируется по регионам',
    excerpt: 'Продолжается подключение поставщиков и акиматов к прозрачной модели, где финансирование следует за ребёнком.',
    image: '19-02',
  },
  {
    tag: 'Стратегия',
    date: '11 апреля 2026',
    title: 'Обновлена дорожная карта трансформации финансирования образования до 2028 года',
    excerpt: 'В фокусе Data Hub, индикаторная модель оценки, цифровой реестр и новые механизмы инвестиционного подхода.',
    image: '17-12',
  },
  {
    tag: 'ОВПО',
    date: '5 апреля 2026',
    title: 'Совершенствуется модель финансирования ОВПО и сопровождения государственного заказа',
    excerpt: 'Финансовый центр продолжает работу по унификации расчётов и цифровизации процедур для вузовского сектора.',
    image: '26-02',
  },
  {
    tag: 'ГОНС',
    date: '29 марта 2026',
    title: 'Цифровые сервисы для получателей образовательных программ становятся доступнее',
    excerpt: 'Расширяется клиентский путь: от консультации и подачи заявки до отслеживания статуса и обратной связи онлайн.',
    image: '27-01',
  },
  {
    tag: 'Стратегия',
    date: '22 марта 2026',
    title: 'Финансовый центр представил концепцию индикаторной модели оценки организаций образования',
    excerpt: 'Новый инструмент позволит объективно оценивать качество управления, финансовую устойчивость и образовательные результаты организаций.',
    image: '24-16',
  },
  {
    tag: 'Дошкольное',
    date: '18 февраля 2026',
    title: 'Обновлены правила финансирования частных дошкольных организаций',
    excerpt: 'Поправки уточняют порядок заключения договоров присоединения и расчёта субсидий на основе фактической посещаемости.',
    image: '18-02',
  },
  {
    tag: 'ОВПО',
    date: '19 мая 2026',
    title: 'Запущен пилотный проект по цифровому сопровождению государственного образовательного заказа в ВУЗах',
    excerpt: 'В рамках пилота отрабатывается автоматическая сверка контингента студентов и расчёт объёма ПНФ через единую платформу.',
    image: '19-05',
  },
  {
    tag: 'Главное',
    date: '22 мая 2026',
    title: 'АО «Финансовый центр» подвело итоги первого квартала 2026 года',
    excerpt: 'Финансирование образования выросло на 12% по сравнению с аналогичным периодом прошлого года. Охват госзаказом превысил 7,5 млн обучающихся.',
    image: '22-05',
  },
];

// ─── FAQ ───
export const FAQ = [
  {
    q: 'Как организации образования переходят на e-Qazyna?',
    a: 'Переход поэтапный: дошкольные учреждения - март 2026, школьное питание - апрель, ТиПО - май, дополнительное образование - июнь, ОВПО - второе полугодие 2026. Каждый этап сопровождается совместным приказом МП, МФ и акиматов.'
  },
  {
    q: 'Что такое ваучерное финансирование в дошкольном образовании?',
    a: 'Механизм, при котором средства следуют за ребёнком: МИО формирует перечень поставщиков, ФЦ размещает договоры присоединения на портале госзакупок, детские сады заполняют табели посещаемости, ФЦ проводит СУР и перечисляет средства. Работает через INDIGO, Balabaqsha, SmartNation и другие ИС МИО.'
  },
  {
    q: 'Как рассчитывается подушевой норматив для ТиПО?',
    a: 'Норматив состоит из ФОТ (55,7%), учебных расходов (16%), учебной литературы (2,1%), амортизации (16,2%), демоэкзамена (1,2%), коммунальных услуг (11,2%) и дуального обучения (3,9%). Колледжи разделены на 4 группы затратности (А-Г) и 3 лиги, что определяет базовый и стимулирующий компонент.'
  },
  {
    q: 'Как работает программа ГОНС «Келешек» и депозит «Акыл»?',
    a: 'ГОНС - система накопления для образования детей. Депозит «Акыл» открывается в банке или страховой компании без ограничения возраста. Государство начисляет премию: 7% для семей СУСН, 5% для всех остальных. Программа «Келешек» предусматривает стартовый капитал (СОК) 60 МРП для детей в 5 лет и ежегодные взносы 24 МРП.'
  },
  {
    q: 'Каковы проблемы с амортизационными компонентами А2/А3 в частных школах?',
    a: 'По 101 школе общая сумма переплаты составит 65,2 млрд тенге, так как договоры заключались без подтверждающих документов о реальной стоимости строительства. Механизм не имел привязки к фактической стоимости объекта. Акиматам поручено урегулировать эти договоры.'
  },
  {
    q: 'Что такое индикаторная модель оценки организаций образования?',
    a: 'Индекс 0-100 по 5 доменам: прозрачность и управление, кадры, финансовая устойчивость, инфраструктура и безопасность, результаты учащихся. Порог 70 баллов: ≥70 - стимулирование и KPI на рост, <70 - план достижения нормы. Рассчитывается автоматически из Data Hub.'
  },
];

// ─── STRATEGY PILLARS (from presentation) ───
export const STRATEGY_PILLARS = [
  { icon: '🔍', title: 'Прозрачность', desc: 'Единый источник данных, публичная методика, аудит след всех операций' },
  { icon: '📊', title: 'Data Hub', desc: '1000+ показателей, ежеквартальный сбор, аналитические дашборды' },
  { icon: '📈', title: 'Индекс', desc: 'Оценка инвестиционной привлекательности школ, колледжей, ВУЗов' },
  { icon: '🎟️', title: 'Ваучер', desc: 'Финансирование следует за учащимся, а не за учреждением' },
  { icon: '🌱', title: 'Инвестиции', desc: 'KASE, DAMU - привлечение частного капитала в образование' },
  { icon: '✅', title: 'Аккредитация', desc: 'Цифровая оценка аккредитации ВУЗов без ручного вмешательства' },
];

// ─── CONTACTS ───
export const CONTACTS = {
  address: '010000, г. Астана, пр. Мәңгілік Ел, 18',
  phone1: '+7 (7172) 69-50-60',
  phone2: '+7 (800) 080-28-28',
  email: 'info@fincenter.kz',
  hours: 'Пн-Пт: 09:00-18:00',
  social: {
    instagram: 'https://instagram.com',
    facebook: 'https://facebook.com',
    linkedin: 'https://linkedin.com',
    telegram: 'https://t.me',
  }
};